export const ratingStatuses = {
  RATED: 'rated',
  UNRATED: 'unrated',
  DISABLED: 'disabled'
};

export const WARNING_MESSAGE = 'You need credits to book sessions.';